import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'
import _ from 'lodash'

import InteractiveReportCommunication from '../sections/communication/components/interactive-report-communication'
import createStore from '../sections/communication/store'
import { SfLog } from '@app/adapters/logger'
import {
  SfEntriesMounter,
  exposeGlobally,
} from '@app/application/report/handlers/sf-entries-mounter.ts'
import { onDocumentEvent } from '@app/utils/domHelpers'
import SFetch from '@app/utils/sfetch'
import SchedulerAdapter from '@app/adapters/schedule'

const initCommunication = ($dom) => () => {
  const detailedEntriesTable = $dom.find(
    ".interactive-report-account [data-behaviour~='detailed-entries-table']"
  )
  const detailedEntries = detailedEntriesTable.data('hash')

  if (detailedEntries) {
    new SfEntriesMounter(detailedEntriesTable[0], detailedEntries, {
      hasMinWidth: true,
      hover: false,
      updateEvent: 'interactive-report-communication:detailed-entries:updated',
    })
  }

  const adjustmentsTable = $dom.find(
    ".interactive-report-account [data-behaviour~='adjustments-table']"
  )
  const adjustments = adjustmentsTable.data('hash')
  if (adjustments) {
    new SfEntriesMounter(adjustmentsTable[0], adjustments, {
      hasMinWidth: true,
      hover: false,
      updateEvent:
        'interactive-report-communication:adjustment-entries:updated',
    })
  }

  $dom
    .find("[data-behaviour~='interactive-report-communication']")
    .each(function () {
      const data = $(this).data()
      const endpointParams = {
        ledgerId: data.ledgerId,
        contextId: data.contextId,
        contextType: 'account',
        ledgerPeriodName: data.ledgerPeriodName,
      }

      const interactiveCommunicationApp = createApp(
        InteractiveReportCommunication,
        {
          singletonId: 'interactive-report-communication',
        }
      )

      interactiveCommunicationApp.use(createStore(endpointParams))
      interactiveCommunicationApp.mount(this)
    })

  // This needs to run after the table data has been loaded because rendering
  // the table will resize the modal and require the graph to be re-rendered
  const SfScheduler = SchedulerAdapter()
  SfScheduler.setTimeout(function () {
    Silverfin.ViewComponents.Chart.Trend.drawAll()
  })
}

onDocumentEvent(
  document,
  'click',
  '[data-behaviour="interactive-report-load-entries"]',
  async function (e) {
    e.preventDefault()
    e.stopPropagation()

    const url = e.target.getAttribute('href')

    try {
      const response = await SFetch.json(
        url,
        {},
        {
          camelizeJSON: false,
        }
      )

      if (Object.keys(response.details).length) {
        window.eventHub.$emit(
          'interactive-report-communication:detailed-entries:updated',
          response.details
        )
      }

      if (Object.keys(response.adjustments).length) {
        window.eventHub.$emit(
          'interactive-report-communication:adjustment-entries:updated',
          response.adjustments
        )
      }

      if (response.hideLoadMore) {
        e.target.remove()
      }
    } catch (e) {
      SfLog.warn('Failed to load entries', {
        extra: {
          error: e,
        },
      })
    }
  }
)

onDomLoad(function ($dom) {
  exposeGlobally()
  const callback = initCommunication($dom)

  // Avoid registering the same callback multiple times, as XHR modals trigger onDomLoad callbacks again
  window.eventHub.$off('interactive-report-communication-opened')

  window.eventHub.$on('interactive-report-communication-opened', callback)

  $(document).one(
    'turbolinks:before-cache turbolinks:before-render',
    function () {
      window.eventHub.$off('interactive-report-communication-opened', callback)
    }
  )

  $(window).off('resize.chart-trend')
  $(window).on(
    'resize.chart-trend',
    _.debounce(function () {
      Silverfin.ViewComponents.Chart.Trend.drawAll()
    }, 100)
  )
})
